
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedback/iframe",
      function () {
        return require("private-next-pages/feedback/iframe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feedback/iframe"])
      });
    }
  